import React, { Component } from 'react';
import { Button } from 'reactstrap';
import './CambiarContrasena.css';
import * as constantClass from './fileWithConstants';

function PasswordToggleIcon({ visible }) {
  if (visible) {
    return (
      <svg className="change-password__toggle-icon" viewBox="0 0 24 24" aria-hidden="true">
        <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7Z" />
        <circle cx="12" cy="12" r="3" />
      </svg>
    );
  }

  return (
    <svg className="change-password__toggle-icon" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M9.9 4.24A10.94 10.94 0 0 1 12 4c6.5 0 10 7 10 7a18.2 18.2 0 0 1-2.16 3.19" />
      <path d="M6.06 6.06A18.2 18.2 0 0 0 2 12s3.5 7 10 7a10.94 10.94 0 0 0 5.24-1.34" />
      <path d="M14.12 14.12a3 3 0 1 1-4.24-4.24" />
      <path d="M1 1l22 22" />
    </svg>
  );
}

function LockIcon() {
  return (
    <svg className="change-password__field-icon" viewBox="0 0 24 24" aria-hidden="true">
      <rect x="5" y="11" width="14" height="10" rx="2" />
      <path d="M8 11V8a4 4 0 0 1 8 0v3" />
    </svg>
  );
}

export class CambiarContrasena extends Component {
  static displayName = CambiarContrasena.name;

  constructor(props) {
    super(props);
    this.state = {
      contraseniaActual: '',
      contraseniaNueva: '',
      contraseniaNuevaConfirmacion: '',
      showActual: false,
      showNueva: false,
      showConfirmacion: false,
      loading: false,
      errorMessage: '',
      successMessage: '',
    };
  }

  handleInputChange = (field) => (event) => {
    this.setState({ [field]: event.target.value, errorMessage: '', successMessage: '' });
  };

  toggleVisibility = (field) => () => {
    this.setState((prev) => ({ [field]: !prev[field] }));
  };

  isFormValid() {
    const { contraseniaActual, contraseniaNueva, contraseniaNuevaConfirmacion } = this.state;
    return (
      contraseniaActual.length > 0 &&
      contraseniaNueva.length > 0 &&
      contraseniaNuevaConfirmacion.length > 0
    );
  }

  handleSubmit = async (event) => {
    event.preventDefault();

    if (this.state.loading) {
      return;
    }

    if (!this.isFormValid()) {
      this.setState({ errorMessage: 'Complete todos los campos.' });
      return;
    }

    if (this.state.contraseniaNueva !== this.state.contraseniaNuevaConfirmacion) {
      this.setState({ errorMessage: 'La nueva contraseña y su confirmación no coinciden.' });
      return;
    }

    this.setState({ loading: true, errorMessage: '', successMessage: '' });

    const { data } = await constantClass.apiFetch('api/user/change-password', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        contraseniaActual: this.state.contraseniaActual,
        contraseniaNueva: this.state.contraseniaNueva,
        contraseniaNuevaConfirmacion: this.state.contraseniaNuevaConfirmacion,
      }),
    });

    if (data === 'Timeout') {
      constantClass.RedirectToLogin();
      return;
    }

    if (constantClass.isApiError(data) || !data.returnModel) {
      this.setState({
        loading: false,
        errorMessage: constantClass.getApiErrorMessage(data, 'No se pudo cambiar la contraseña.'),
      });
      return;
    }

    this.setState({
      loading: false,
      contraseniaActual: '',
      contraseniaNueva: '',
      contraseniaNuevaConfirmacion: '',
      showActual: false,
      showNueva: false,
      showConfirmacion: false,
      successMessage: 'La contraseña se actualizó correctamente.',
    });
  };

  render() {
    const {
      loading,
      errorMessage,
      successMessage,
      contraseniaActual,
      contraseniaNueva,
      contraseniaNuevaConfirmacion,
      showActual,
      showNueva,
      showConfirmacion,
    } = this.state;

    return (
      <div className="change-password-page">
        <header className="change-password-page__header">
          <h1 className="change-password-page__title">Cambiar Contraseña</h1>
          <p className="change-password-page__subtitle">
            Ingrese su contraseña actual y defina una nueva contraseña para su cuenta.
          </p>
        </header>

        <div className="change-password-page__card">
          <form className="change-password-page__form" onSubmit={this.handleSubmit} noValidate>
            <div className="change-password-page__feedback" aria-live="polite" role="status">
              {errorMessage ? <span className="change-password-page__error">{errorMessage}</span> : null}
              {successMessage ? <span className="change-password-page__success">{successMessage}</span> : null}
              {loading ? (
                <span className="change-password-page__loading">Procesando cambio de contraseña...</span>
              ) : null}
            </div>

            <div className="change-password__field">
              <label className="change-password__label" htmlFor="cp-actual">
                Contraseña actual
              </label>
              <div className="change-password__input-wrap">
                <span className="change-password__input-icon" aria-hidden="true">
                  <LockIcon />
                </span>
                <input
                  id="cp-actual"
                  className="change-password__input"
                  type={showActual ? 'text' : 'password'}
                  placeholder="Ingrese su contraseña actual"
                  autoComplete="current-password"
                  disabled={loading}
                  value={contraseniaActual}
                  onChange={this.handleInputChange('contraseniaActual')}
                />
                <button
                  type="button"
                  className="change-password__toggle"
                  onClick={this.toggleVisibility('showActual')}
                  disabled={loading}
                  aria-label={showActual ? 'Ocultar contraseña actual' : 'Mostrar contraseña actual'}
                  aria-pressed={showActual}
                >
                  <PasswordToggleIcon visible={showActual} />
                </button>
              </div>
            </div>

            <div className="change-password__field">
              <label className="change-password__label" htmlFor="cp-nueva">
                Nueva contraseña
              </label>
              <div className="change-password__input-wrap">
                <span className="change-password__input-icon" aria-hidden="true">
                  <LockIcon />
                </span>
                <input
                  id="cp-nueva"
                  className="change-password__input"
                  type={showNueva ? 'text' : 'password'}
                  placeholder="Ingrese su nueva contraseña"
                  autoComplete="new-password"
                  disabled={loading}
                  value={contraseniaNueva}
                  onChange={this.handleInputChange('contraseniaNueva')}
                />
                <button
                  type="button"
                  className="change-password__toggle"
                  onClick={this.toggleVisibility('showNueva')}
                  disabled={loading}
                  aria-label={showNueva ? 'Ocultar nueva contraseña' : 'Mostrar nueva contraseña'}
                  aria-pressed={showNueva}
                >
                  <PasswordToggleIcon visible={showNueva} />
                </button>
              </div>
            </div>

            <div className="change-password__field">
              <label className="change-password__label" htmlFor="cp-confirmacion">
                Confirmar nueva contraseña
              </label>
              <div className="change-password__input-wrap">
                <span className="change-password__input-icon" aria-hidden="true">
                  <LockIcon />
                </span>
                <input
                  id="cp-confirmacion"
                  className="change-password__input"
                  type={showConfirmacion ? 'text' : 'password'}
                  placeholder="Confirme su nueva contraseña"
                  autoComplete="new-password"
                  disabled={loading}
                  value={contraseniaNuevaConfirmacion}
                  onChange={this.handleInputChange('contraseniaNuevaConfirmacion')}
                />
                <button
                  type="button"
                  className="change-password__toggle"
                  onClick={this.toggleVisibility('showConfirmacion')}
                  disabled={loading}
                  aria-label={showConfirmacion ? 'Ocultar confirmación' : 'Mostrar confirmación'}
                  aria-pressed={showConfirmacion}
                >
                  <PasswordToggleIcon visible={showConfirmacion} />
                </button>
              </div>
            </div>

            <Button
              type="submit"
              color="primary"
              className="change-password-page__submit"
              disabled={loading}
            >
              Guardar contraseña
            </Button>
          </form>
        </div>
      </div>
    );
  }
}
